import {
  CiIcon, DefaultIcon, DsIcon, GiIcon, GsrIcon, HiIcon, IiIcon,
  IsrIcon, LoanIcon, MiIcon, RespIcon, SfIcon, SiIcon, TiIcon,
  VrIcon, SmsIcon,
} from 'ia-react-core';
import React, { FC } from 'react';
import { LobCode } from './LobCode';

export interface LobIconProps {
  code: LobCode;
}

const LobIcon: FC<LobIconProps> = ({ code }) => {
  switch (code) {
    case 'ci':
      return (<CiIcon />);

    case 'ds':
      return (<DsIcon />);

    case 'gi':
      return (<GiIcon />);

    case 'gsr':
      return (<GsrIcon />);

    case 'hi':
      return (<HiIcon />);

    case 'ii':
      return (<IiIcon />);

    case 'isr':
      return (<IsrIcon />);

    case 'loan':
      return (<LoanIcon />);

    case 'mi':
      return (<MiIcon />);

    case 'resp':
      return (<RespIcon />);

    case 'sf':
      return (<SfIcon />);

    case 'si':
      return (<SiIcon />);

    case 'sms':
      return (<SmsIcon />);

    case 'ti':
      return (<TiIcon />);

    case 'vr':
      return (<VrIcon />);

    default:
      return (<DefaultIcon />);
  }
};

LobIcon.displayName = 'LobIcon';

export default LobIcon;
